require('./card.component.scss');

class CardController {
  constructor(
    $scope,
    $timeout,
    $element,
    CurrentFilterService,
    PermissionService,
    LayoutService,
    RouterService,
  ) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.CurrentFilterService = CurrentFilterService;
    this.listOpened = false;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
    this.keysFilter = ['agent_account.guid', 'agent_account.id', 'agent_agent.guid', 'agent_agent.id'];

    $scope.$on('FilterDataLoaded', () => {
      const el = this.$element.closest('.sc-view-container-fit-card');
      if (el[0]) el.scrollTop(0);
    });
  }
}

export const CardComponent = {
  template: require('./card.component.html'),
  bindings: {
    filter: '<',
    card: '<',
  },
  controller: CardController,
};



// WEBPACK FOOTER //
// ./src/view/dashboard/card.component.js